<template>
  <Teleport to="head">
    <slot />
  </Teleport>
</template>
